module.exports = __webpack_public_path__ + "img/3dots.8d76f4bc.svg";